import React from "react";
import "./RaikoGridStylesheet.scss"

const RaikoGridThreeColumn = (
    {
        children,
        className
    }) => {

    return (
        <div className={`gridThreeColumnContainer ${className}`}>
            {children}
        </div>
    )
}

export default RaikoGridThreeColumn